import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { ZonesAparcareFilter } from '../../models/zones-aparcare-filter';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ZonaAparcare } from '../../models/zona-aparcare.model';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { ZonesAparcareService } from '../../services/zones-aparcare.service';
import { ZonesAparcareFilterService } from '../../services/zones-aparcare-filter.service';

@Component({
  selector: 'app-zones-aparcare-table',
  templateUrl: './zones-aparcare-table.component.html',
  styleUrls: ['./zones-aparcare-table.component.scss']
})
export class ZonesAparcareTableComponent implements OnInit, OnChanges, AfterViewInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  data: ZonaAparcare[];
  dataSource: CustomDataSource<ZonaAparcare, ZonesAparcareFilter>;
  filter: ZonesAparcareFilter = new ZonesAparcareFilter('descripcio', 'asc');
  displayedItems = [];
  highlightedRows = [];

  @Input() selectButton: boolean;
  @Input() updatedFilterData: ZonesAparcareFilter;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ['codi', 'descripcio', 'dataInici', 'dataFi'];

  constructor(
    private zonesAparcareService: ZonesAparcareService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
  }

  ngOnInit() {
    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<ZonaAparcare, ZonesAparcareFilter>(this.paginator, new ZonesAparcareFilterService(), 'urlGetZonesAparcare', 'urlGetZonesAparcareCount');
    this.dataSource.subject.subscribe((data) => {
      data.forEach(item => {
        this.displayedItems[item.secureID] = {
          id: item.secureID
        };
      });
    });

    this.filter.filterUpdated.subscribe(updated => {
      if (updated) {
        this.load();
        if (!this.selectButton) { this.filterService.saveFilter('zones-aparcare-filter', this.filter); }
      }
    });

    if (!this.selectButton) { this.filterService.loadFilter('zones-aparcare-filter', this.filter); }
    this.filter.paginator.init(this.sort, this.paginator);
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.filter.paginator.set(this.sort, this.paginator);
      this.filter.updated();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.filter.updated()))
    .subscribe();

    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatedFilterData != null) {
      this.update();
    }
  }

  update() {
    if (this.dataSource !== undefined) {
      this.updatedFilterData.paginator.set(this.sort, this.paginator);
      this.dataSource.loadFilter(this.updatedFilterData);
    }
  }

  load() {
    this.filter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.filter);
  }

  onRowClicked(row) {
    this.itemClicked.next(row.secureID);
  }

}
